export default {
      id: "icon-calendar-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "icons.svg#icon-calendar",
      toString: function () {
        return this.url;
      }
    }